import { render, staticRenderFns } from "./HasPermissionTable.vue?vue&type=template&id=25f677a0&scoped=true"
import script from "./HasPermissionTable.vue?vue&type=script&lang=js"
export * from "./HasPermissionTable.vue?vue&type=script&lang=js"
import style0 from "./HasPermissionTable.vue?vue&type=style&index=0&id=25f677a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f677a0",
  null
  
)

export default component.exports